import React from 'react';
import { Alert, Card, Divider, List, Space, Tag, Typography } from 'antd';
import {
	DatabaseOutlined,
	SafetyOutlined,
	ThunderboltOutlined,
} from '@ant-design/icons';

const { Paragraph, Text, Title } = Typography;

const capabilities = [
	'Crear tenant nuevo desde Synapse Feed sin usar el pipeline legacy.',
	'Seguir jobs de aprovisionamiento y revisar cada step del provisioning.',
	'Cambiar el correo primario del administrador y reenviar su onboarding.',
	'Operar sobre endpoints administrativos protegidos por tenant_admin.',
];

export default function TenantsMenu() {
	return (
		<div style={{ padding: 16 }}>
			<Space direction='vertical' size='middle' style={{ width: '100%' }}>
				<Card bordered={false}>
					<Space direction='vertical' size='small' style={{ width: '100%' }}>
						<Space align='center'>
							<DatabaseOutlined />
							<Title level={5} style={{ margin: 0 }}>
								Tenants
							</Title>
						</Space>
						<Paragraph type='secondary' style={{ marginBottom: 0 }}>
							Módulo operacional administrativo para aprovisionar clientes
							nuevos en Synapse.
						</Paragraph>
						<Space wrap>
							<Tag color='blue'>Feed custom route</Tag>
							<Tag color='purple'>/feed/tenants</Tag>
						</Space>
					</Space>
				</Card>

				<Alert
					showIcon
					type='info'
					message='Acceso operacional'
					description='El frontend expone el entrypoint, pero el backend valida tenant_admin para provisioning y el permiso explícito de gestión de contratas para corregir el onboarding.'
				/>

				<Card bordered={false}>
					<Title level={5}>Qué puedes hacer aquí</Title>
					<List
						dataSource={capabilities}
						renderItem={item => (
							<List.Item>
								<Text>{item}</Text>
							</List.Item>
						)}
					/>
					<Divider style={{ margin: '12px 0' }} />
					<Space direction='vertical' size='small'>
						<Space>
							<SafetyOutlined />
							<Text strong>Permisos requeridos:</Text>
							<Text code>tenant_admin / gestor de contratas</Text>
						</Space>
						<Space>
							<ThunderboltOutlined />
							<Text strong>Baseline actual:</Text>
							<Text code>v2</Text>
						</Space>
					</Space>
				</Card>
			</Space>
		</div>
	);
}
